var _rect, _g, _rect2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_247_1393",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.0302734,
    width: 24,
    height: 24,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_247_1393)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_247_1393",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_247_1393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.80775 21C4.31058 21 3.885 20.823 3.531 20.469C3.177 20.115 3 19.6894 3 19.1923V5.80775C3 5.31058 3.177 4.885 3.531 4.531C3.885 4.177 4.31058 4 4.80775 4H9.25775C9.32058 3.44483 9.56292 2.97275 9.98475 2.58375C10.4064 2.19458 10.9131 2 11.5048 2C12.0964 2 12.6032 2.19458 13.025 2.58375C13.4468 2.97275 13.6859 3.44483 13.7423 4H18.1923C18.6894 4 19.115 4.177 19.469 4.531C19.823 4.885 20 5.31058 20 5.80775V19.1923C20 19.6894 19.823 20.115 19.469 20.469C19.115 20.823 18.6894 21 18.1923 21H4.80775ZM4.80775 19.5H18.1923C18.2692 19.5 18.3398 19.4679 18.4038 19.4038C18.4679 19.3398 18.5 19.2693 18.5 19.1923V5.80775C18.5 5.73075 18.4679 5.66025 18.4038 5.59625C18.3398 5.53208 18.2692 5.5 18.1923 5.5H4.80775C4.73075 5.5 4.66025 5.53208 4.59625 5.59625C4.53208 5.66025 4.5 5.73075 4.5 5.80775V19.1923C4.5 19.2693 4.53208 19.3398 4.59625 19.4038C4.66025 19.4679 4.73075 19.5 4.80775 19.5ZM7.5 17.1345H12.5C12.7125 17.1345 12.8906 17.0626 13.0343 16.9187C13.1781 16.7751 13.25 16.5969 13.25 16.3842C13.25 16.1718 13.1781 15.9937 13.0343 15.85C12.8906 15.7065 12.7125 15.6348 12.5 15.6348H7.5C7.2875 15.6348 7.10942 15.7066 6.96575 15.8503C6.82192 15.9941 6.75 16.1723 6.75 16.385C6.75 16.5975 6.82192 16.7756 6.96575 16.9193C7.10942 17.0628 7.2875 17.1345 7.5 17.1345ZM7.5 13.25H15.5C15.7125 13.25 15.8906 13.1781 16.0343 13.0343C16.1781 12.8904 16.25 12.7122 16.25 12.4998C16.25 12.2871 16.1781 12.109 16.0343 11.9655C15.8906 11.8218 15.7125 11.75 15.5 11.75H7.5C7.2875 11.75 7.10942 11.8219 6.96575 11.9658C6.82192 12.1096 6.75 12.2878 6.75 12.5003C6.75 12.7129 6.82192 12.891 6.96575 13.0345C7.10942 13.1782 7.2875 13.25 7.5 13.25ZM7.5 9.36525H15.5C15.7125 9.36525 15.8906 9.29342 16.0343 9.14975C16.1781 9.00592 16.25 8.82767 16.25 8.615C16.25 8.4025 16.1781 8.22442 16.0343 8.08075C15.8906 7.93725 15.7125 7.8655 15.5 7.8655H7.5C7.2875 7.8655 7.10942 7.93742 6.96575 8.08125C6.82192 8.22492 6.75 8.40308 6.75 8.61575C6.75 8.82825 6.82192 9.00633 6.96575 9.15C7.10942 9.2935 7.2875 9.36525 7.5 9.36525ZM11.5 4.84625C11.7167 4.84625 11.8958 4.77542 12.0375 4.63375C12.1792 4.49208 12.25 4.31292 12.25 4.09625C12.25 3.87958 12.1792 3.70042 12.0375 3.55875C11.8958 3.41708 11.7167 3.34625 11.5 3.34625C11.2833 3.34625 11.1042 3.41708 10.9625 3.55875C10.8208 3.70042 10.75 3.87958 10.75 4.09625C10.75 4.31292 10.8208 4.49208 10.9625 4.63375C11.1042 4.77542 11.2833 4.84625 11.5 4.84625Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoboardIcon);
export default __webpack_public_path__ + "static/media/infoboard-icon.ae537dc7a31af4d21ccf9855db67447a.svg";
export { ForwardRef as ReactComponent };